/**
 * Document print/email status helpers.
 * Status key is rec_id + group_id (never visit_id). Merge only fields that changed.
 */

export function toDocumentStatusBool (value) {
  return value === true || value === 1 || value === '1' || value === 'true'
}

export function buildDocumentStatusPayload ({ group_id, rec_id, printed, emailed, remarks } = {}) {
  const groupId = Number(group_id)
  const recId = Number(rec_id)
  if (!groupId || !recId) return null

  const payload = {
    group_id: groupId,
    rec_id: recId
  }

  if (printed === true) payload.printed = true
  if (emailed === true) payload.emailed = true
  if (remarks != null && String(remarks).trim() !== '') payload.remarks = String(remarks)

  if (payload.printed === undefined && payload.emailed === undefined && payload.remarks === undefined) {
    return null
  }
  return payload
}

export function applyDocumentStatusPatch (row, patch) {
  if (!row || !patch) return row
  const next = { ...row }
  if (Object.prototype.hasOwnProperty.call(patch, 'printed')) {
    next.printed = patch.printed === true
  }
  if (Object.prototype.hasOwnProperty.call(patch, 'emailed')) {
    next.emailed = patch.emailed === true
  }
  return next
}

export function applyDocumentStatusToRows (rows, rec_id, patch) {
  const recId = Number(rec_id)
  if (!Array.isArray(rows) || !recId) return rows
  return rows.map((row) => {
    if (!row || Number(row.rec_id) !== recId) return row
    return applyDocumentStatusPatch(row, patch)
  })
}

export function getDocumentRecordFromDocData (docData) {
  if (!docData) return null
  const nested = docData.data && Array.isArray(docData.data.records) ? docData.data.records[0] : null
  if (nested) return nested
  if (Array.isArray(docData.records) && docData.records[0]) return docData.records[0]
  return null
}

/** Document types that render a ส่งอีเมล button (RHCF prescription). */
const EMAIL_PAGE_TEMPLATES = ['rhcfpres.html']
const EMAIL_SUBCLASS_IDS = [17]

export function documentCanSendEmail (item) {
  if (!item || typeof item !== 'object') return false
  const template = String(item.page_template || item.Page_Template || '').trim().toLowerCase()
  if (EMAIL_PAGE_TEMPLATES.indexOf(template) !== -1) return true
  const subclassId = Number(item.subclass_id ?? item.Subclass_Id ?? item.subclassId)
  return EMAIL_SUBCLASS_IDS.indexOf(subclassId) !== -1
}
